module.exports = __webpack_public_path__ + "media/images/app_store-6daa48f21cd6c0723a6823532b8244c5.png";